import { ProductTileModel } from "@api/mappers/products.mapper";

export const findCeil = (ar: Array<number>, x: number) => {
    const arTemp = [...ar];
    arTemp.push(x);
    arTemp.sort();
    const i = arTemp.indexOf(x);
    return ar[i];
};

export const epdmRol = (
    availableDefaultSizes: Array<{
        size: number;
        product: ProductTileModel;
    }>,
    length: number, // in meter
    width: number, // in meter
) => {
    const epdmInfo: Array<{ product?: ProductTileModel; amount: number }> = [];
    let excludeBottomWidths = false;

    let roundedWidth = Math.round(width * 10) / 10;
    if (roundedWidth < width) {
        roundedWidth = roundedWidth + 0.1;
    }

    let roundedLength = Math.round(length * 10) / 10;
    if (roundedLength < length) {
        roundedLength = roundedLength + 0.1;
    }

    if (roundedWidth > 7 && roundedLength > 7) {
        roundedWidth = (roundedWidth % 7) + 0.2;
        epdmInfo.push({
            product: availableDefaultSizes.find(s => s.size === 7)?.product,
            amount: (roundedWidth - (roundedWidth % 7)) / 7,
        });
        excludeBottomWidths = true;
    }

    const defaultWidth = findCeil(
        availableDefaultSizes
            .filter(p =>
                excludeBottomWidths ? [0.7, 1.4].some(x => x !== p.size) : true,
            )
            .map(p => p.size),
        roundedWidth,
    );
    const defaultLength = findCeil(
        availableDefaultSizes.map(p => p.size),
        roundedLength,
    );

    const calc1 = defaultWidth * roundedLength;
    const calc2 = defaultLength * roundedWidth;

    let chosenDefaultWidth: number;
    let chosenLength;
    if (calc1 < calc2) {
        chosenDefaultWidth = defaultWidth;
        chosenLength = roundedLength;
    } else {
        chosenDefaultWidth = defaultLength;
        chosenLength = roundedWidth;
    }

    const epdmRolProduct = availableDefaultSizes.find(
        s => s.size === chosenDefaultWidth!,
    )?.product;

    const epdmRolAmount = Math.max(2, chosenLength) / 0.1;

    epdmInfo.push({ product: epdmRolProduct, amount: epdmRolAmount });

    return epdmInfo;
};
